import { taskCitationsService } from '@/services/task-citations.service';

const initialState = () => ({
  citations: [],
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  getTaskCitations({ commit }, { opportunityId, taskId }) {
    commit('GET_TASK_CITATIONS');
    return taskCitationsService.getTaskCitations({ opportunityId, taskId }).then(
      (citations) => {
        commit('GET_TASK_CITATIONS_SUCCESS', citations);
        return citations;
      },
      (error) => {
        commit('GET_TASK_CITATIONS_ERROR', error);
        throw error;
      },
    );
  },
  createTaskCitation({ commit }, { opportunityId, taskId, citation }) {
    commit('CREATE_TASK_CITATION');
    return taskCitationsService.createTaskCitation({ opportunityId, taskId, citation }).then(
      (created) => {
        commit('CREATE_TASK_CITATION_SUCCESS', created);
        commit('tasks/UPDATE_OPPORTUNITY_TASK_CITATIONS', { taskId, newCitation: created }, { root: true });
        return created;
      },
      (error) => {
        commit('CREATE_TASK_CITATION_ERROR', error);
        throw error;
      },
    );
  },
  deleteTaskCitation({ commit }, { opportunityId, taskId, citationId }) {
    commit('DELETE_TASK_CITATION');
    return taskCitationsService.deleteTaskCitation({ opportunityId, taskId, citationId }).then(
      () => {
        commit('DELETE_TASK_CITATION_SUCCESS', citationId);
        commit('tasks/REMOVE_OPPORTUNITY_TASK_CITATION', { taskId, citationId }, { root: true });
      },
      (error) => {
        commit('DELETE_TASK_CITATION_ERROR', error);
        throw error;
      },
    );
  },
  RESET({ commit }) {
    commit('RESET_STORE');
  },
};

const mutations = {
  GET_TASK_CITATIONS(state) {
    state.status = { error: null, pending: true, resolved: false, rejected: false };
    state.citations = [];
  },
  GET_TASK_CITATIONS_SUCCESS(state, citations) {
    state.status = { ...state.status, pending: false, resolved: true };
    state.citations = citations;
  },
  GET_TASK_CITATIONS_ERROR(state, error) {
    state.status = { ...state.status, pending: false, rejected: true, error };
    state.citations = [];
  },
  CREATE_TASK_CITATION(state) {
    state.status = { error: null, pending: true, resolved: false, rejected: false };
  },
  CREATE_TASK_CITATION_SUCCESS(state, citation) {
    state.status = { ...state.status, pending: false, resolved: true };
    state.citations = [...state.citations, citation];
  },
  CREATE_TASK_CITATION_ERROR(state, error) {
    state.status = { ...state.status, pending: false, rejected: true, error };
  },
  DELETE_TASK_CITATION(state) {
    state.status = { error: null, pending: true, resolved: false, rejected: false };
  },
  DELETE_TASK_CITATION_SUCCESS(state, citationId) {
    state.status = { ...state.status, pending: false, resolved: true };
    state.citations = state.citations.filter((c) => c.id !== citationId);
  },
  DELETE_TASK_CITATION_ERROR(state, error) {
    state.status = { ...state.status, pending: false, rejected: true, error };
  },
  RESET_STORE(state) {
    const initial = initialState();
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  },
};

const getters = {
  citations: (state) => state.citations,
  citationsPending: (state) => state.status.pending,
  citationsResolved: (state) => state.status.resolved,
  citationsRejected: (state) => state.status.rejected,
};

export const taskCitations = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
